
define('template!threadsThreadDraftView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="draft-header">\n    <span class="draft-badge">Draft</span>\n    <span class="draft-status">' +
((__t = ( statusText )) == null ? '' : __t) +
'</span>\n</div>\n<div class="draft-fields">\n    <div class="field-row">\n        <label>To:</label>\n        <input type="text" class="draft-to" value="' +
((__t = ( toAddresses )) == null ? '' : __t) +
'" />\n    </div>\n    <div class="field-row">\n        <label>Cc:</label>\n        <input type="text" class="draft-cc" value="' +
((__t = ( ccAddresses )) == null ? '' : __t) +
'" />\n    </div>\n    <div class="field-row">\n        <label>Subject:</label>\n        <input type="text" class="draft-subject" value="' +
((__t = ( subject )) == null ? '' : __t) +
'" />\n    </div>\n</div>\n<div class="draft-body">\n    <div class="draft-message" contenteditable="true">' +
((__t = ( content )) == null ? '' : __t) +
'</div>\n</div>\n<div class="attachments-region"></div>\n<div class="draft-actions">\n    <button class="btn-discard" ';
 if(!hasDraftId) { ;
__p += 'disabled';
 } ;
__p += '>Discard</button>\n    <button class="btn-save" ';
 if(!hasDraftId) { ;
__p += 'disabled';
 } ;
__p += '>Save draft</button>\n    <label class="notify-reply" title="' +
((__t = ( _.i18n('emails.notifyOnReply.title', null, 'You get a notification when the first reply comes into this conversation') )) == null ? '' : __t) +
'">\n        <input type="checkbox" class="notify-reply-check" />\n        <span>' +
((__t = ( _.i18n('emails.notifyOnReply', null, 'Notify me of a reply') )) == null ? '' : __t) +
'</span>\n    </label>\n    <button class="btn-send">Send</button>\n</div>\n';

}
return __p
};});

